import { contentConstants } from '../constants/content.constants';

/**
 * Custom hook to check if the content attachment count exceeds a specified limit.
 * @param {Object} params
 * @param {Array} params.attachments - The current list of attachments.
 * @param {number} params.limit - The maximum allowed number of attachments.
 * @returns {{ currentCount: number, isLimitReached: boolean }}
 */
export function checkContentAttachmentsLimit({ 
    attachments = [], 
    selected_files = [],
    limit = contentConstants.MAX_ATTACHMENT_COUNT,
    alert = false 
}) {
    const currentCount = attachments.length;
    const isLimitReached = currentCount >= limit;
    const isLimitReachedWithSelectedFiles = (currentCount + selected_files.length) > limit;

    if (isLimitReachedWithSelectedFiles && alert) {
        alert(`You can only upload a maximum of ${limit} attachments.`);
    }

    return { isLimitReachedWithSelectedFiles, isLimitReached }
}
